import { render, staticRenderFns } from "./topStats.vue?vue&type=template&id=5c239e7d&"
import script from "./topStats.vue?vue&type=script&lang=js&"
export * from "./topStats.vue?vue&type=script&lang=js&"
import style0 from "./topStats.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports